import { render, staticRenderFns } from "./FeedTankCorrectionSettings.vue?vue&type=template&id=4d2f7c92&"
import script from "./FeedTankCorrectionSettings.vue?vue&type=script&lang=ts&"
export * from "./FeedTankCorrectionSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports